<template>
  <div v-loading="!isProcessed">
    <el-table
      v-if="isProcessed"
      :data="paginatedProcessed"
      stripe
      size="mini"
      style="overflow-x: scroll;"
    >
      <template v-for="(key, index) in Object.keys(processed[0])">
        <el-table-column
          :key="index"
          :label="key"
          :prop="key"
        >
          <template slot-scope="props">
            {{ props.row[key] ? props.row[key] : '-' }}
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[5, 10, 20, 30]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true
    },
    parsed: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      processed: [],
      isProcessed: false,
      page: 1,
      perPage: 5,
      total: 0
    }
  },
  computed: {
    paginatedProcessed () {
      let startIndex = (this.page * this.perPage) - this.perPage
      let endIndex = startIndex + this.perPage
      return this.processed.slice(startIndex, endIndex)
    }
  },
  created () {
    this.form.config = this.$sheep.getConfig(this.form.carrier.name.toLowerCase().replace(/\s/g, '').replace(/[\W_]+/g, ''))
    this.processed = this.$sheep.applyActions(this.parsed, this.form.config)
    this.$nextTick(() => {
      if (this.processed && this.processed.length > 0) {
        this.total = this.processed.length
        this.isProcessed = true
        this.$emit('processed', this.processed)
      }
    })
  }
}
</script>

<style>

</style>
